import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const setupDatadog = () => {

  const onecommConfigurations = window['onecommConfigurations' as any] as any

  if (
    onecommConfigurations.NODE_ENV !== 'development' &&
    onecommConfigurations.REACT_APP_DATADOG_APPLICATION_ID &&
    onecommConfigurations.REACT_APP_DATADOG_CLIENT_TOKEN
  ) {
    datadogRum.init({
      applicationId: onecommConfigurations.REACT_APP_DATADOG_APPLICATION_ID,
      clientToken: onecommConfigurations.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'onecomm-admin',
      env: onecommConfigurations.NODE_ENV === 'production' ? 'production' : 'staging',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
       (url) => url.startsWith(onecommConfigurations.REACT_APP_URL_API),
    ],
  });

  datadogRum.setGlobalContextProperty('business_unit', 'bcp');
  datadogRum.setGlobalContextProperty('invoiced_team', 'ce-onecomm');

  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
      clientToken: onecommConfigurations.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'onecomm-admin',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      env: onecommConfigurations.NODE_ENV === 'production' ? 'production' : 'staging',
      forwardConsoleLogs: 'all',
    });
  }
};

export default setupDatadog;